import React from 'react';

import Button from 'components/Button';

const ReloadButton = () => {
  return (
    <Button
      key="containers.App.generalErrorReloadButtonText"
      onClick={() => {
        window.location.reload();
      }}
      variant="secondary"
      title={{ id: 'containers.App.generalErrorReloadButtonText' }}
    />
  );
};

export default ReloadButton;
